import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";
import buySteps from "./buySteps";

const StepBuy_1 = () => {
  const { goToStep } = useWizard();

  const handleYesStep = () => {
    return goToStep(buySteps.sureSteps.step_1);
  };

  const handleNoStep = () => {
    return goToStep(buySteps.step_2);
  };

  return (
    <BaseStep
      text="Вы знаете что хотите приобрести?"
      yesStep={handleYesStep}
      noStep={handleNoStep}
    />
  );
};

export default StepBuy_1;
